<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div>
      <div class="flex items-center justify-center">
        <check-icon />
      </div>
      <div class="">
        <div
          class="w-full flex flex-col items-center mt-4 text-black-10"
          style="word-break: normal"
        >
          <h3 class="text-2xl font-bold text-center mb-6">
            Payout In Progress
          </h3>
          <p class="font-normal text-center w-11/12 lg:w-4/5">
            We are processing your payout, simplifying your financial
            interactions
          </p>
          <div>
            <el-button
              test-id="completePayout"
              class="flex justify-center bg-primary w-full py-3.5 text-white rounded-md text-sm font-normal mt-8"
              @click="handleClose"
            >
              Done
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  components: {
    CheckIcon: () => import('@/assets/v2/icons/SuccessCheckIcon.vue')
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
      this.$store.dispatch('bulkPayout/resetBulkPayoutState')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  }
}
</script>

<style scoped>
* >>> .el-dialog {
  border-radius: 16px;
  padding: 5px;
  background-color: white;
}
* >>> .el-dialog__close .el-icon .el-icon-close {
  color: black !important;
}
</style>
